import { render } from "./StructNode.vue?vue&type=template&id=25833d2c"
import script from "./StructNode.vue?vue&type=script&lang=js"
export * from "./StructNode.vue?vue&type=script&lang=js"

import "./StructNode.vue?vue&type=style&index=0&id=25833d2c&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__